/**
 * Implementation of the bootstrap modal
 */
'use strict'

var Marionette = require('marionette'),
  ModalRegion

ModalRegion = Marionette.Region.extend({
  initialize: function () {},
  onShow: function (args) {
    this.listenTo(args.currentView, 'dialog:close', this.closeDialog)
    // console.log(view)
    var self = this
    this.$el.modal({
      show: true,
      fade: false
    })
  },
  onEmpty: function (view) {
    this.closeDialog()
  },
  closeDialog: function () {
    this.stopListening()
    this.$el.modal('hide')
  }
})

module.exports = ModalRegion



// WEBPACK FOOTER //
// ./js/components/modal/modalRegion.js